import {
    CREATE_BROKER_FIRM_FAILURE,
    CREATE_BROKER_FIRM_REQUEST,
    CREATE_BROKER_FIRM_RESETSTATE,
    CREATE_BROKER_FIRM_SUCCESS,
    DELETE_BROKER_FIRM_FAILURE,
    DELETE_BROKER_FIRM_REQUEST,
    DELETE_BROKER_FIRM_SUCCESS,
    FETCH_BROKER_FIRMS_FAILURE,
    FETCH_BROKER_FIRMS_REQUEST,
    FETCH_BROKER_FIRMS_SUCCESS,
    UPDATE_BROKER_FIRM_FAILURE,
    UPDATE_BROKER_FIRM_REQUEST,
    UPDATE_BROKER_FIRM_SUCCESS
} from './types';

/**
 *
 * @param {Object} [params]
 * @returns
 */
export const fetchBrokerFirms = (params) => ({
  type: FETCH_BROKER_FIRMS_REQUEST,
  payload: params,
});

/**
 *
 * @param {BrokerFirmListState} data
 * @returns
 */
export const fetchBrokerFirmsSuccess = (data) => ({
  type: FETCH_BROKER_FIRMS_SUCCESS,
  payload: data,
});

/**
 *
 * @param {String} error
 * @returns
 */
export function fetchBrokerFirmsFailure(error) {
  return {
    type: FETCH_BROKER_FIRMS_FAILURE,
    error,
  };
}

/**
 *
 * @param {Object} [params]
 * @returns
 */
export const createBrokerFirm = (params) => ({
  type: CREATE_BROKER_FIRM_REQUEST,
  payload: params,
});

export const createBrokerFirmsSuccess = (data) => ({
  type: CREATE_BROKER_FIRM_SUCCESS,
  payload: data,
});

/**
 *
 * @param {String} error
 * @returns
 */
export function createBrokerFirmsFailure(error) {
  return {
    type: CREATE_BROKER_FIRM_FAILURE,
    error,
  };
}

/**
 *
 * @param {String} error
 * @returns
 */
export function createBrokerFirmsReset() {
  return {
    type: CREATE_BROKER_FIRM_RESETSTATE,
  };
}

/**
 *
 * @param {BrokerFirm} params
 * @returns
 */
export const updateBrokerFirm = (params) => ({
    type: UPDATE_BROKER_FIRM_REQUEST,
    payload: params
});

export const updateBrokerFirmsSuccess = (data) => ({
    type: UPDATE_BROKER_FIRM_SUCCESS,
    payload: data
});

/**
 *
 * @param {String} error
 * @returns
 */
export function updateBrokerFirmsFailure(error) {
    return {
        type: UPDATE_BROKER_FIRM_FAILURE,
        error
    };
}

/**
 *
 * @param {Object} [params]
 * @returns
 */
export const deleteBrokerFirm = (params) => ({
    type: DELETE_BROKER_FIRM_REQUEST,
    payload: params
});

export const deleteBrokerFirmsSuccess = (data) => ({
    type: DELETE_BROKER_FIRM_SUCCESS,
    payload: data
});

/**
 *
 * @param {String} error
 * @returns
 */
export function deleteBrokerFirmsFailure(error) {
    return {
        type: DELETE_BROKER_FIRM_FAILURE,
        error
    };
}
